import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: {},
  isPinEntered: false,
  counter: 0,
  isProfileLoaded: false,
};
const accountSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    addUserData: (state, action) => {
      state.userData = action.payload?.userData ?? state.userData;
      state.isPinEntered = action.payload?.isPinEntered ?? state.isPinEntered;
      if (action.payload?.counter !== undefined) {
        state.counter = action.payload.counter;
      }
      if (action.payload?.isProfileLoaded !== undefined) {
        state.isProfileLoaded = action.payload.isProfileLoaded;
      } else if (action.payload?.userData !== undefined) {
        state.isProfileLoaded = true;
      }
    },
    addCounter: (state, action) => {
      state.counter = action.payload;
    },
    changeAddressData: (state, action) => {
      state.userData = {
        ...state.userData,
        address: { ...action.payload },
      };
    },
    changeIdentificationDetails: (state, action) => {
      state.userData = {
        ...state.userData,
        dob: action.payload.dob,
        ssn: action.payload.ssn,
      };
    },
    changeAccreditedDetails: (state, action) => {
      state.userData = {
        ...state.userData,
        role: action.payload.role,
        investorStatus: action.payload.investorStatus,
        isRegDInvestor: action.payload.isRegDInvestor,
      };
    },
    changePersonalDetails: (state, action) => {
      state.userData = {
        ...state.userData,
        email: action.payload.email,
        phoneNumber: action.payload.phoneNumber,
      };
    },
    changeLegalName: (state, action) => {
      state.userData = {
        ...state.userData,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
      };
    },
    falseEmailVerifyed: (state, action) => {
      state.userData = {
        ...state.userData,
        isEmailVerified: false,
      };
    },
    trueEmailVerifyed: (state, action) => {
      state.userData = {
        ...state.userData,
        isEmailVerified: true,
      };
    },
    trueMobileVerifyed: (state, action) => {
      state.userData = {
        ...state.userData,
        isPhoneVerified: true,
      };
    },
    resetUserData: (state) => {
      state.userData = {};
      state.isPinEntered = false;
      state.counter = 0;
      state.isProfileLoaded = false;
    },
  },
});

export const {
  addUserData,
  changeAddressData,
  changeIdentificationDetails,
  changeAccreditedDetails,
  changePersonalDetails,
  changeLegalName,
  addCounter,
  resetUserData,
  falseEmailVerifyed,
  trueEmailVerifyed,
  trueMobileVerifyed,
} = accountSlice.actions;

export default accountSlice.reducer;
